import * as React from "react";
import styled from "styled-components";
import {
  ConfirmSignIn,
  ConfirmSignUp,
  ForgotPassword,
  RequireNewPassword,
  SignUp,
  VerifyContact,
  withAuthenticator
} from "aws-amplify-react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/de";
import { LocaleProvider } from "antd";
import de_DE from "antd/lib/locale-provider/de_DE";
import { Auth, I18n } from "aws-amplify";
import { Layout } from "antd";

import BookDirectContainer from "./features/bookDirect/components/BookDirectContainer";
import BookDirectSummaryContainer from "./features/bookDirect/components/BookDirectSummaryContainer";
import RecurringContainer from "./features/bookRecurring/components/RecurringContainer";
import BookRecurringSuccess from "./features/bookRecurring/components/BookSuccess";
import OrdersContainer from "./features/orders/components/OrdersContainer";
import OrderDetailsContainer from "./features/orders/components/OrderDetailsContainer";
import AddressesContainer from "./features/addresses/components/AddressesContainer";
import AccountContainer from "./features/settings/AccountContainer";
import InvoicesContainer from "./features/invoices/components/InvoicesContainer";
import InvoiceDetailsContainer from "./features/invoices/components/InvoiceDetailsContainer";
import "./App.css";
import ForwardSignIn from "./features/signIn/ForwardSignIn";
import { ForwardSider } from "./shared/ForwardSider";
import BookMultiContainer from "./features/bookMulti/components/BookMultiContainer";
import BookMultiSummaryContainer from "./features/bookMulti/components/BookMultiSummaryContainer";
import { Tracker } from "./lib/Tracker";
import { fetchOrdersAsync } from "./features/orders/actions";
import { OrdersFilter } from "./lib/model/OrdersFilter";

moment.locale("de");
I18n.setLanguage("de");

const { Content } = Layout;

const StyledContent = styled(Content)`
  padding-left: 287px;
  background-color: #e8e8e8;

  @media only screen and (max-width: 1200px) {
    padding-left: 0;
  };
`

const mapStateToProps = () => ({
});

const dispatchProps = {
  fetchOrders: fetchOrdersAsync.request
}

type Props = typeof dispatchProps;

class App extends React.Component<Props> {
  render() {
    return (
      <Layout>
        <ForwardSider />
        <StyledContent>
          <Route exact path="/" component={BookDirectContainer} />
          <Route exact path="/summary" component={BookDirectSummaryContainer} />
          <Route exact path="/multi" component={BookMultiContainer} />
          <Route
            exact
            path="/multisummary"
            component={BookMultiSummaryContainer}
          />
          <Route exact path="/recurring" component={RecurringContainer} />
          <Route exact path="/recurring-success" component={BookRecurringSuccess} />
          <Route exact path="/orders" component={OrdersContainer} />
          <Route
            exact
            path="/orders/:orderId"
            component={OrderDetailsContainer}
          />
          <Route exact path="/addresses" component={AddressesContainer} />
          <Route exact path="/invoices" component={InvoicesContainer} />
          <Route
            exact
            path="/invoices/:invoiceId"
            component={InvoiceDetailsContainer}
          />
          <Route exact path="/settings" component={AccountContainer} />
        </StyledContent>
      </Layout>
    );
  }

  componentDidMount = () => {
    this.initializeTracking();
    // preload the orders in the redux store before creating an order
    this.props.fetchOrders({ filter: OrdersFilter.Open });
  };

  initializeTracking = async () => {
    const user = await Auth.currentAuthenticatedUser();
    Tracker.Instance.loggedIn(
      user.attributes["custom:shipperId"],
      user.attributes.email,
      user.attributes.name
    );
  };
}

const ConnectedApp = connect(mapStateToProps, dispatchProps)(App);

export default (props: any) => {
  const AuthenticatedApp = withAuthenticator(ConnectedApp, false, [
    <ForwardSignIn authState="" onStateChange={() => {}} />,
    <ConfirmSignIn />,
    <VerifyContact />,
    <SignUp />,
    <ConfirmSignUp />,
    <ForgotPassword />,
    <RequireNewPassword />
  ]);
  return (
    <LocaleProvider locale={de_DE}>
      <AuthenticatedApp {...props} />
    </LocaleProvider>
  );
};
